import React from 'react'
import config from '../config.json'

const _source = () => {return window.localStorage.getItem(config.tokenName)}

export 
    const Context =  React.createContext({
        auth:null,
        loading:true
    })

export const roleCheck = (target_roles) => {
    let role = localStorage.getItem(config.roleName)
    if(role === "admin" || target_roles.includes(role))
        return true
    else
        return false
}

export const roleTag = () => {
    let role = localStorage.getItem(config.roleName)
    switch(role) {
        case "admin":
            return "Admin";
        case "system_manager":
            return "S.Manager";
        default:
            return "User";
        }
}

export 
    function Provider({source, ...rest}){
        const [auth, setAuth] = React.useState(false)
        const [loading, setLoading] = React.useState(true)
        React.useEffect(() => setAuth(source?source(auth):_source()), [])
        React.useEffect(() => setLoading(false), [auth])
        
        return (
            <Context.Provider value={{auth, loading}}>
                {rest.children}
            </Context.Provider>
        )
    }